function packMat4IntoF32(view, mat, offsetFloats = 0, srcOffsetFloats = 0) {
  const src = mat;
  if (srcOffsetFloats === 0 && src.length === 16) {
    view.set(src, offsetFloats);
    return;
  }
  const s = srcOffsetFloats;
  const o = offsetFloats;
  view[o + 0] = src[s + 0];
  view[o + 1] = src[s + 1];
  view[o + 2] = src[s + 2];
  view[o + 3] = src[s + 3];
  view[o + 4] = src[s + 4];
  view[o + 5] = src[s + 5];
  view[o + 6] = src[s + 6];
  view[o + 7] = src[s + 7];
  view[o + 8] = src[s + 8];
  view[o + 9] = src[s + 9];
  view[o + 10] = src[s + 10];
  view[o + 11] = src[s + 11];
  view[o + 12] = src[s + 12];
  view[o + 13] = src[s + 13];
  view[o + 14] = src[s + 14];
  view[o + 15] = src[s + 15];
}

export { packMat4IntoF32 };
//# sourceMappingURL=pack-mat4-into-f32.js.map
